export const blockIconsHardwareHeadphonesNew = (
	<span className='material-symbols-outlined'>headphones</span>
);
